<template>
  <div>
    <list
      row-key="OtherReceivId"
      ref="list"
      unit="核销单"
      light-row
      @row-select="x=>$emit('change', x)"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="核销类型" label-width="100px">
          <el-select size="mini" v-model="params.CancelTypeId" @change="typeChange" placeholder="请选择">
            <el-option label="收款核销" :value="0"></el-option>
            <el-option label="付款核销" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据编号" label-width="100px">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请输入单据编号" />
        </el-form-item>
        <el-form-item label="单据日期" v-if="!isMB" label-width="100px">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <!-- <el-form-item label="核销单据日期" v-if="!isMB" label-width="100px">
          <range-picker
            :date="[params.DateStart, params.DateEnd]"
            @change="x=>{params.DateStart=x.Start;params.DateEnd=x.End;}"
          />
        </el-form-item> -->
        <el-form-item label="往来单位" label-width="100px">
          <!-- <select-input
            placeholder="请选择单位"
            :label="params.TradeUnitName"
            v-model="params.TradeUnitId"
            @click="openTradeunit"
          /> -->
           <customer @restaurants='setSupplier' :state='params.TradeUnitName'/>
        </el-form-item>
        <el-form-item label="单据日期" v-if="isMB" label-width="100px">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" v-if="isMB" label-width="100px">
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="核销单据日期" v-if="isMB" label-width="100px">
          <el-date-picker
            v-model.trim="params.DateStart"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="核销截止日期" v-if="isMB" label-width="100px">
          <el-date-picker
            v-model.trim="params.DateEnd"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择结束时间"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocNo" label="单据编号" min-width="110" />
        <el-table-column prop="DocDate" label="单据日期" min-width="100">
          <template slot-scope="{ row }">{{ $commonJs.toDateString(row.DocDate) }}</template>
        </el-table-column>
        <el-table-column prop="CancelTypeId" label="核销类型" min-width="100">
          <template slot-scope="{row}">
            <span v-if="row.CancelTypeId==0">收款核销</span>
            <span v-else>付款核销</span>
          </template>
        </el-table-column>
        <el-table-column prop="FirstUnitName" label="往来单位" min-width="130" show-overflow-tooltip />
        <el-table-column prop="CurrentTotalAmount" label="核销金额" />
        <el-table-column prop="ClerkName" label="经办人" />
        <el-table-column prop="Memo" label="备注" min-width="140" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <tradeunit-dialog ref="tradeunitDialog" selectable @select="setTradeunit" />
  </div>
</template>
<script>
import customer from "@/components/common/customer/customer";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import tradeunitDialog from "@/components/basicinfo/basic/logistics/listDialog";

export default {
  mixins: [listMixin],
  components: { list, tradeunitDialog,customer },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      api: require("@/api/fund/contactcash/woDoc").default,
      params: {
        CancelTypeId: 0, //收款核销/付款核销
        TradeUnitId: null,
        TradeUnitName:"",
        // BusinessTypeId: null,
        DocNo: null,
        DocDateStart: this.$commonJs.getToday(), //单据日期
        DocDateEnd: this.$commonJs.getToday(), //单据日期
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    setSupplier(data) {
      console.log(data)
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
      console.log(this.params)
    },
    typeChange(type) {
      this.$emit("type-change", type);
      this.query();
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.Id;
      this.params.TradeUnitName = data.Name;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.$emit("reload");
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>